<template>
  <div class="card-917">
    <div class="ag-courses_item">
      <div class="ag-courses-item_link">
        <div class="ag-courses-item_bg"></div>

        <div class="ag-courses-item_title m-0 p-0 row">

          <div class="col-6 p-0 m-0">
            <slot name="p-1"></slot>
          </div>

          <div class="col-6 p-0 m-0">
            <slot name="p-2"></slot>
          </div>

          <div class="col-12 p-0 m-0">
            <slot name="p-3"></slot>
          </div>

        </div>

      </div>
    </div>

  </div>
</template>

<script>
import mA from '../Tags/A'
import mImg from '../Tags/Img'
import {CardProps} from "./CardProps";

export default {
  name: "Card917",
  components: {
    mA,
    mImg,
  },
  props: {
    ...CardProps
  },

}

</script>

<style scoped>
.ag-courses_item {
  -ms-flex-preferred-size: calc(33.33333% - 30px);
  flex-basis: calc(33.33333% - 30px);
  overflow: hidden;
  border-radius: 28px;
}

.ag-courses-item_link {
  display: block;
  padding: 30px 20px;
  background-color: #121212;
  overflow: hidden;
  position: relative;
}

.ag-courses-item_link:hover {
  text-decoration: none;
  color: #FFF;
}

.ag-courses-item_link:hover .ag-courses-item_bg {
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1);
}

.ag-courses-item_title :deep(*) {
  color: #FFF;
}

.ag-courses-item_title {
  min-height: 87px;
  margin: 0 0 25px;
  overflow: hidden;
  font-weight: bold;
  z-index: 2;
  position: relative;
}

.ag-courses-item_bg {
  height: 128px;
  width: 128px;
  background-color: var(--primary);

  z-index: 1;
  position: absolute;
  top: -75px;
  right: -75px;

  border-radius: 50%;

  -webkit-transition: all .5s ease;
  -o-transition: all .5s ease;
  transition: all .5s ease;

  -webkit-transform: scale(10);
  -ms-transform: scale(10);
  transform: scale(10);

}


@media only screen and (max-width: 979px) {
  .ag-courses_item {
    -ms-flex-preferred-size: calc(50% - 30px);
    flex-basis: calc(50% - 30px);
  }

  .ag-courses-item_title {
    font-size: 24px;
  }
}

@media only screen and (max-width: 639px) {
  .ag-courses_item {
    -ms-flex-preferred-size: 100%;
    flex-basis: 100%;
  }

  .ag-courses-item_title {
    min-height: 72px;
    line-height: 1;

    font-size: 24px;
  }

  .ag-courses-item_link {
    padding: 22px 40px;
  }

}


</style>